import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import { NewTag } from '../../../../styled-components/shared';
import { type SportId } from '../../../../types/sports';
import LineUpIcon from '../common/LineUpIcon';

const StyleReceiver = styled.div`
  position: relative;
  margin-right: 0.6em;

  width: 2em;
  height: 2em;

  border-radius: 50%;

  z-index: 1;
  transition: none 200ms ease-in-out;
  transition-property: transform, filter;

  &:active {
    transform: scale(0.95);
  }

  ${Target.__MOBILE__
    ? undefined
    : css`
        &:hover,
        &:active {
          filter: brightness(110%);
        }
      `}
`;

export const LineUpOpenViewButtonWrapperClassName = 'line-up-open-view-button-wrapper';
const Wrapper = styled.div`
  position: relative;

  background-color: #292e3d;

  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: inherit;
`;

const StyledLineUpIcon = styled(LineUpIcon)`
  height: 1.2em;
  width: 2em;
`;

const StyledNewTag = styled(NewTag)`
  position: absolute;
  top: 100%;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
  background-color: unset;
  margin: 0;
`;

type SeeLineUpButtonProps = {
  className?: string;
  isNew?: boolean;
  sportId: SportId;
  onClick: () => void;
};

const LineUpOpenViewButton = ({ className = '', sportId, isNew = false, onClick }: SeeLineUpButtonProps) => {
  return (
    <StyleReceiver className={className}>
      <Wrapper className={LineUpOpenViewButtonWrapperClassName} onClick={onClick}>
        <StyledLineUpIcon sportId={sportId} />
        {isNew ? <StyledNewTag>New</StyledNewTag> : null}
      </Wrapper>
    </StyleReceiver>
  );
};

export default LineUpOpenViewButton;
